import { NgModule } from '@angular/core';
import { FiSelectedFilesListComponent } from './selected-files-list.component';
import { FiFilePreviewModule } from '../file-preview/file-preview.module';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
    imports: [CommonModule, FiFilePreviewModule, MatProgressBarModule],
    declarations: [FiSelectedFilesListComponent],
    exports: [FiSelectedFilesListComponent],
})
export class FiSelectedFilesListModule {}
